import { useEffect } from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { AIAgentType } from '@/modules/aiAgents/components/AIAgentType/AIAgentType';
import { CREATE_AI_AGENT_OPTIONS } from '@/modules/aiAgents/constants';
import { BrainType } from '@/shared/types/brain';

import { Form } from './ModalAIAgentCreate';

export const Step1 = () => {
  const { control, setValue, unregister, getValues } = useFormContext<Form>();

  useEffect(() => {
    unregister('name');
    unregister('language');
    unregister('provider');
    unregister('language_model_id');
  }, [unregister]);

  return (
    <Controller
      name="brain_type"
      control={control}
      defaultValue={getValues('brain_type') ?? null}
      render={({ field }) => {
        return (
          <div className="grid max-h-[472px] grid-cols-2 gap-4 overflow-y-auto [&>button]:flex [&>button]:flex-col [&>button]:self-stretch">
            {CREATE_AI_AGENT_OPTIONS.map((type) => {
              return (
                <AIAgentType
                  type={type}
                  handleClick={(e) => {
                    e.preventDefault();
                    setValue('brain_type', type as BrainType, { shouldValidate: true });
                  }}
                  isSelected={field.value === type}
                  key={type}
                />
              );
            })}
          </div>
        );
      }}
    />
  );
};
